import { graphql } from '../gql';

export const getUpcomingPopupEventDetails = graphql(`
  query GetUpcomingPopupEventDetails($input: GetEventVendorsInput!) {
    getEventVendors(input: $input) {
      error {
        code
        message
      }
      eventVendors {
        ... on PopupEventVendor {
          id
          confirmed
          productType
          usesFoodaPos
          historical(limit: 5) {
            id
            sales {
              mealsSold
            }
            popupEvent {
              eventStartTime
            }
          }
          mealPrep {
            prepFor
            factors {
              type
              value
            }
          }
          menuTemplate {
            name
          }
          vendor {
            id
            internalName
            address {
              id
              address1
              address2
              city
              state
              zipCode
              country
            }
          }
          popupEvent {
            id
            status
            startTime: eventStartTime
            endTime: eventEndTime
            productType
            setupTime
            account {
              name
            }
          }
          eventLocation {
            id
            setupTime
            serviceStartTime
            stationType
            location {
              id
              name
              buildingAddressNotes
              cafeLocation {
                id
                name
              }
              building {
                id
                name
                address {
                  id
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                }
              }
              siteDirectionsDocUrl
            }
          }
        }
      }
    }
  }
`);
